// 动漫网分类数据：包含动画分类与漫画分类
export interface Category {
  id: string;
  name: string;
  type: 'anime' | 'manga';
  tag: string;
  desc: string;
  image: string;
}

// 动画分类
export const animeCategories: Category[] = [
  {
    id: 'ri',
    name: '日漫',
    type: 'anime',
    tag: '日漫',
    desc: '来自日本的经典动画作品',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20sakura%20petals%20and%20torii%20gate%20over%20a%20modern%20japanese%20city%20at%20sunset%2C%20warm%20coral%20orange%20and%20golden%20glow%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20soft%20atmosphere&width=600&height=400&seq=cat-ri&orientation=landscape',
  },
  {
    id: 'guo',
    name: '国漫',
    type: 'anime',
    tag: '国漫',
    desc: '国产动画的崛起之作',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20chinese%20ink%20paintings%20and%20dragon%20silhouette%20over%20ancient%20mountains%20with%20red%20lanterns%2C%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20cultural%20atmosphere&width=600&height=400&seq=cat-guo&orientation=landscape',
  },
  {
    id: 'new',
    name: '新番',
    type: 'anime',
    tag: '新番',
    desc: '每季热播的最新动画',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20sparkling%20stars%20and%20fireworks%20over%20a%20night%20city%20with%20neon%20signs%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20festive%20energy&width=600&height=400&seq=cat-new&orientation=landscape',
  },
  {
    id: 'shonen',
    name: '热血',
    type: 'anime',
    tag: '热血',
    desc: '战斗与羁绊的热血之作',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20a%20fierce%20young%20warrior%20holding%20a%20flaming%20sword%20with%20energy%20shockwaves%2C%20warm%20coral%20orange%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20dynamic%20action&width=600&height=400&seq=cat-shonen&orientation=landscape',
  },
  {
    id: 'fantasy',
    name: '奇幻',
    type: 'anime',
    tag: '奇幻',
    desc: '魔法与冒险的幻想世界',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20a%20floating%20magic%20island%20with%20castles%20and%20glowing%20runes%20under%20a%20warm%20sky%2C%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20dreamy%20adventure&width=600&height=400&seq=cat-fantasy&orientation=landscape',
  },
  {
    id: 'romance',
    name: '恋爱',
    type: 'anime',
    tag: '恋爱',
    desc: '心动与甜蜜的恋爱故事',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20a%20romantic%20couple%20under%20cherry%20blossoms%20with%20warm%20golden%20light%20and%20soft%20bokeh%2C%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20heartfelt%20atmosphere&width=600&height=400&seq=cat-romance&orientation=landscape',
  },
  {
    id: 'comedy',
    name: '搞笑',
    type: 'anime',
    tag: '搞笑',
    desc: '捧腹大笑的欢乐作品',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20a%20group%20of%20happy%20chibi%20characters%20laughing%20and%20playing%20with%20confetti%20and%20balloons%2C%20bright%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20playful%20energy&width=600&height=400&seq=cat-comedy&orientation=landscape',
  },
  {
    id: 'scifi',
    name: '科幻',
    type: 'anime',
    tag: '科幻',
    desc: '未来世界与尖端科技',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20a%20mecha%20silhouette%20against%20a%20huge%20planet%20and%20spaceships%20in%20a%20warm%20cosmic%20sky%2C%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20futuristic%20scale&width=600&height=400&seq=cat-scifi&orientation=landscape',
  },
  {
    id: 'healing',
    name: '治愈',
    type: 'anime',
    tag: '治愈',
    desc: '温暖人心的治愈系作品',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20a%20cozy%20cottage%20with%20warm%20windows%20and%20lush%20green%20meadow%20under%20gentle%20sunshine%2C%20soft%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20tranquil%20warmth&width=600&height=400&seq=cat-healing&orientation=landscape',
  },
];

// 漫画分类
export const mangaCategories: Category[] = [
  {
    id: 'm-boy',
    name: '少年漫',
    type: 'manga',
    tag: '少年漫',
    desc: '充满热血与冒险的少年向漫画',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20manga%20illustration%20of%20a%20young%20hero%20jumping%20with%20a%20giant%20sword%20and%20speed%20lines%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20dynamic%20battle&width=600&height=400&seq=cat-mboy&orientation=landscape',
  },
  {
    id: 'm-girl',
    name: '少女漫',
    type: 'manga',
    tag: '少女漫',
    desc: '细腻唯美的少女向漫画',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20manga%20illustration%20of%20a%20elegant%20girl%20in%20a%20flowing%20dress%20surrounded%20by%20roses%20and%20soft%20light%2C%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20romantic%20elegance&width=600&height=400&seq=cat-mgirl&orientation=landscape',
  },
  {
    id: 'm-youth',
    name: '青年漫',
    type: 'manga',
    tag: '青年漫',
    desc: '面向成年读者的深度漫画',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20manga%20illustration%20of%20a%20mature%20samurai%20silhouette%20in%20rain%20under%20a%20deep%20sky%2C%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20serious%20dramatic%20tone&width=600&height=400&seq=cat-myouth&orientation=landscape',
  },
  {
    id: 'm-comedy',
    name: '搞笑漫画',
    type: 'manga',
    tag: '搞笑漫画',
    desc: '轻松爆笑的漫画作品',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20manga%20illustration%20of%20funny%20cartoon%20characters%20making%20silly%20faces%20with%20comic%20sound%20effect%20text%2C%20bright%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20humorous%20energy&width=600&height=400&seq=cat-mcomedy&orientation=landscape',
  },
  {
    id: 'm-hot',
    name: '热血漫画',
    type: 'manga',
    tag: '热血漫画',
    desc: '竞技与战斗的热血漫画',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20manga%20illustration%20of%20sports%20players%20mid%20action%20with%20energy%20flames%20and%20dynamic%20speed%20lines%2C%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20competitive%20spirit&width=600&height=400&seq=cat-mhot&orientation=landscape',
  },
];

export const allCategories: Category[] = [...animeCategories, ...mangaCategories];